import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { kioskService } from '@/api/admin/services/kiosk.service';
import type { KioskPayload } from '@/types/dashboard/kiosk';

export const kioskKeys = { list: ['admin', 'kiosks'] as const };

export function useKiosks() {
  return useQuery({ queryKey: kioskKeys.list, queryFn: () => kioskService.list() });
}

export function useCreateKiosk() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: KioskPayload) => kioskService.create(payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: kioskKeys.list }),
  });
}

export function useUpdateKiosk() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: Partial<KioskPayload> }) =>
      kioskService.update(id, payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: kioskKeys.list }),
  });
}

export function useDeleteKiosk() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => kioskService.remove(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: kioskKeys.list }),
  });
}
